import React, { useContext } from "react";
import Moment from "react-moment";
import { Report } from ".";
import arrowRightBigIcon from "../../assets/images/arrow-right-big.svg";
import { SanityNode } from "../../config/build/models/node";
import { HydrationContext } from "../../context/HydrationContext";
import useTranslations from "../../hooks/useTranslations";
import { isNullOrWhiteSpace } from "../../shared/string";
import LinkWithArrow from "../LinkWithArrow";
import SanityLink from "../SanityLink";

interface Props {
  title?: string;
  items: Report[];
  archiveLinkReference?: SanityNode;
}

const PressReleasesCard = ({ title, items, archiveLinkReference }: Props) => {
  const translations = useTranslations();

  if (archiveLinkReference) {
    archiveLinkReference.title = translations.allPressReleases ?? "";
  }

  const hydrated = useContext(HydrationContext);

  return (
    <div className="flex flex-col py-6">
      {!isNullOrWhiteSpace(title) && <h2 className="text-current">{title}</h2>}
      <ul className="flex flex-col mb-3 mt-4">
        {items.map((pressRelease, index) => (
          <li key={index} className="mb-4 last:mb-0">
            <SanityLink
              reference={pressRelease}
              className="card-basic group hover:border-brand-primary-70 focus:outline-none focus:shadow-card-outline text-brand-primary-20 flex items-center justify-between w-full p-3 no-underline"
            >
              <div className="flex flex-col justify-between">
                <p className="text-xs text-subheader-primary font-bold uppercase mb-1">
                  {hydrated ? (
                    <Moment format={"LLL"}>{pressRelease.publishDate}</Moment>
                  ) : (
                    <>&nbsp;</>
                  )}
                </p>
                <p className="text-brand-primary-20 mb-0 font-bold leading-tight">
                  {pressRelease.title}
                </p>
              </div>
              <div className="pl-3 flex flex-grow justify-end items-center">
                <svg className="card-arrow fill-current group-hover:text-brand-primary-70 w-8 h-8">
                  <use xlinkHref={arrowRightBigIcon.url} />
                </svg>
              </div>
            </SanityLink>
          </li>
        ))}
      </ul>
      <div className="flex justify-end">
        <LinkWithArrow
          linkInfo={{
            reference: archiveLinkReference,
            title: translations.allPressReleases ?? ""
          }}
        />
      </div>
    </div>
  );
};

export default PressReleasesCard;
